import { motion } from "framer-motion";

type Props = {
  label: string;
  current: number;
  total: number;
  value: number;
  className?: string;
};

export function ProgressMeter({
  label,
  current,
  total,
  value,
  className = "",
}: Props) {
  return (
    <div
      className={`progress-meter ${className}`}
      aria-label={`${label}: ${current} of ${total}`}
    >
      <div className="progress-meter-meta">
        <strong>{label}</strong>
        <span>
          {current}/{total}
        </span>
      </div>
      <div className="progress-track" aria-hidden="true">
        <motion.span
          animate={{ width: `${value}%` }}
          transition={{ duration: 0.28, ease: "easeOut" }}
        />
      </div>
    </div>
  );
}
